import type { AbilityBuilder, MongoQuery } from '@casl/ability'
import type { AppAbility } from '~/types/authorization.type'
import type { TimeEntry } from '~/types/timeEntry.type'
import type { User } from '~/types/user.type'
import { userRoles } from '../roles'

export function defineTimeEntryAbilities(abilityBuilder: AbilityBuilder<AppAbility>, user: User) {
  const { can, cannot } = abilityBuilder

  can('read', 'timesheets')

  const roles = userRoles(user)

  type TimeEntryQuery = MongoQuery<TimeEntry>
  type TimeEntryKeys = keyof TimeEntry | Array<keyof TimeEntry>

  if (roles.administrator || roles.client_lead) {
    can(['create', 'read', 'update', 'delete', 'restore'], 'time-entry')
  }
  else {
    /* Own entries */
    can(['read', 'create', 'update', 'delete'], 'time-entry', {
      userId: user.id,
    } as TimeEntryQuery)

    /* Leads */
    can(['read', 'create'], 'time-entry', {
      'project.leads.id': user.id,
    } as TimeEntryQuery)
    can('update', 'time-entry', ['taskId', 'projectId', 'notes'] as TimeEntryKeys, {
      'userId': {
        $ne: user.id,
      },
      'project.leads.id': user.id,
    } as TimeEntryQuery)

    if (roles.people_lead || roles.hr || roles.time_entry_auditor) {
      can('read', 'time-entry')
    }

    // Deny admin-only fields
    cannot(['create', 'update'], 'time-entry', ['isBilled', 'userId'] as TimeEntryKeys)
  }
}
